import styled from 'styled-components';
import { createGradientOrSolid } from '../../Helper/utils/utils';

type Me2onSpecialOfferProps = {
    backgroundImage: any;
    backgroundColor: any;
    buttonColor: any;
};

export const StyledMe2onSpecialOffer = styled.div<Me2onSpecialOfferProps>`
    box-sizing: border-box;
    border-radius: 15px;
    background: var(--bundle-border-color);
    font-family: var(--font-family), Arial;
    width: 100%;
    max-width: 400px;
    min-width: 343px;
    height: 200px;
    padding: 4px;
    position: relative;

    .container {
        background: ${({ backgroundImage, backgroundColor }: any) =>
            backgroundImage
                ? `url("${backgroundImage}")`
                : createGradientOrSolid(backgroundColor)};
        width: 100%;
        height: 100%;
        border-radius: 0.75rem;
        background-size: cover;
        background-position: center;

        .products {
            display: flex;
            justify-content: space-around;
            align-items: center;
            height: 100%;

            .product {
                display: flex;
                align-items: center;
                flex-direction: column;
                width: 100px;
                &:first-child {
                    margin-left: 24px;
                }
                &:last-child {
                    margin-right: 24px;
                }

                &-container {
                    width: 85px;
                    height: 85px;

                    &--image {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                &-amount {
                    margin-top: 12px;
                    text-align: center;
                    font-size: 0.875rem;
                    font-style: normal;
                    font-weight: 700;
                    line-height: normal;
                    text-transform: uppercase;
                    color: #fff;
                    text-shadow: 0 -1px 0.2px #000, 0 1px 0.2px #000,
                        -1px 0 0.2px #000, 1px 0 0.2px #000, 1px 1px 0.2px #000,
                        -1px -1px 0.2px #000, -1px 1px 0.2px #000,
                        1px -1px 0.2px #000;
                }

                .stroked {
                    font-size: 0.75rem;
                    font-weight: 500;
                    color: #fff;
                    position: relative;
                    margin: 0;
                    text-shadow: 0 -1px 0.2px #000, 0 1px 0.2px #000,
                        -1px 0 0.2px #000, 1px 0 0.2px #000, 1px 1px 0.2px #000,
                        -1px -1px 0.2px #000, -1px 1px 0.2px #000,
                        1px -1px 0.2px #000;

                    &::after {
                        content: ' ';
                        height: 2px;
                        width: 100%;
                        background: #d8232a;
                        position: absolute;
                        left: 0;
                        top: 50%;
                    }
                }
            }
        }

        .price-container {
            position: absolute;
            left: 50%;
            bottom: -18px;
            transform: translateX(-50%);

            .availability {
                text-align: center;
                color: black;
                margin-bottom: 4px;
                font-size: 12px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                color: white;
                text-shadow: 0 -1px 0.2px #000, 0 1px 0.2px #000,
                    -1px 0 0.2px #000, 1px 0 0.2px #000, 1px 1px 0.2px #000,
                    -1px -1px 0.2px #000, -1px 1px 0.2px #000,
                    1px -1px 0.2px #000;
            }

            .price {
                padding: 6px;
                height: auto;
                border-radius: 4px;
                width: 140px;
                background: ${({ buttonColor }: any) =>
                    buttonColor &&
                    createGradientOrSolid(buttonColor, !!buttonColor.colorTwo)};
                box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.8);
                overflow: hidden;

                .white_stripe {
                    border-top-left-radius: 4px;
                    border-top-right-radius: 4px;
                }

                .totalPrice {
                    font-size: 1.25rem;
                    font-style: normal;
                    font-weight: 700;
                    line-height: normal;
                    text-transform: capitalize;
                }
            }
        }
    }
`;
